__turbopack_context__.v({
  "TextWrapper": "gulfstreamComponent-module-scss-module__X_1uVq__TextWrapper",
  "blockTitle": "gulfstreamComponent-module-scss-module__X_1uVq__blockTitle",
  "componentTitle": "gulfstreamComponent-module-scss-module__X_1uVq__componentTitle",
  "gulfstreamComponentBlock": "gulfstreamComponent-module-scss-module__X_1uVq__gulfstreamComponentBlock",
  "gulfstreamComponentTopWrapper": "gulfstreamComponent-module-scss-module__X_1uVq__gulfstreamComponentTopWrapper",
  "gulfstreamComponentWrapper": "gulfstreamComponent-module-scss-module__X_1uVq__gulfstreamComponentWrapper",
  "gulfstreamImage": "gulfstreamComponent-module-scss-module__X_1uVq__gulfstreamImage",
  "text": "gulfstreamComponent-module-scss-module__X_1uVq__text",
});
